/** Custom edge with a label chip: outcome / condition summary / "por defecto". */
import { memo } from 'react';
import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath, type EdgeProps } from '@xyflow/react';
import { Icono } from '@xiltrion/ui/icono';
import { describeCondition, type DEdge } from './model';
import { useDesigner } from './store';

export const edgeTypes = {
  wf: memo(({ id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, data, selected, markerEnd }: EdgeProps<DEdge>) => {
    const [path, lx, ly] = getSmoothStepPath({ sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, borderRadius: 12 });
    const hasIssue = useDesigner((s) => s.issues.some((i) => i.edgeId === id && i.level === 'error'));
    const wf = data?.wf;
    const cond = wf?.condition ? describeCondition(wf.condition) : '';
    const text = wf?.label || wf?.outcome || (cond ? cond : '');
    const stroke = selected ? 'var(--primary)' : hasIssue ? 'var(--destructive)' : 'var(--muted-foreground)';
    return (
      <>
        <BaseEdge id={id} path={path} markerEnd={markerEnd} style={{ stroke, strokeWidth: selected ? 2.5 : 1.8, strokeDasharray: wf?.isDefault ? '6 4' : undefined }} />
        {(text || wf?.isDefault) && (
          <EdgeLabelRenderer>
            <div className={`nodrag nopan absolute text-[11px] px-1.5 py-0.5 rounded border bg-card shadow-sm max-w-[180px] truncate pointer-events-auto ${selected ? 'border-primary text-primary' : 'border-border text-foreground'}`} style={{ transform: `translate(-50%, -50%) translate(${lx}px, ${ly}px)` }} title={[text, cond && text !== cond ? cond : '', wf?.isDefault ? 'Por defecto' : ''].filter(Boolean).join(' · ')}>
              {wf?.isDefault && <Icono nombre="mdi:arrow-decision-auto" className="inline mr-0.5 align-[-2px]" aria-label="Por defecto" />}
              {text || 'por defecto'}
            </div>
          </EdgeLabelRenderer>
        )}
      </>
    );
  }),
};
